import React from 'react'

const DrupalContext = React.createContext()

export default DrupalContext
